module.exports = __webpack_public_path__ + "img/vertical_3_6_6000.bd3c752f.png";